module.exports = __webpack_public_path__ + "static/pejnovic-9a6a8845378ad59fb831700e42fd0171.jpg";